/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { i as isNumber_1 } from '../../_chunks/dep-a432d90f.mjs';
import { i as isObject_1 } from '../../_chunks/dep-4efc69ee.mjs';
import { i as isArray_1 } from '../../_chunks/dep-0d1bd08c.mjs';
import { i as isEmpty_1 } from '../../_chunks/dep-ec227f3f.mjs';
import '../../_chunks/dep-6f3e4f56.mjs';
import '../../_chunks/dep-b1060562.mjs';
import '../../_chunks/dep-b333ab93.mjs';
import '../../_chunks/dep-8049d2e0.mjs';
import '../../_chunks/dep-18bb982b.mjs';
import '../../_chunks/dep-25d66c95.mjs';
import '../../_chunks/dep-372265bb.mjs';
import '../../_chunks/dep-97c71289.mjs';
import '../../_chunks/dep-ae08d6c4.mjs';
import '../../_chunks/dep-d940e2da.mjs';
import '../../_chunks/dep-e50fa7b0.mjs';
import '../../_chunks/dep-c57d8117.mjs';
import '../../_chunks/dep-c7e4942d.mjs';
import '../../_chunks/dep-c5d88cfe.mjs';

function getSingleContent(cascaderContext) {
  var value = cascaderContext.value,
    multiple = cascaderContext.multiple,
    treeStore = cascaderContext.treeStore,
    showAllLevels = cascaderContext.showAllLevels;
  if (multiple || value !== 0 && !value) return "";
  if (isArray_1(value)) return "";
  var node = treeStore && treeStore.getNodes(value);
  if (!(node && node.length)) {
    return value;
  }
  var path = node && node[0].getPath();
  if (path && path.length) {
    return showAllLevels ? path.map(function (node2) {
      return node2.label;
    }).join(" / ") : path[path.length - 1].label;
  }
  return value;
}
function getMultipleContent(cascaderContext) {
  var value = cascaderContext.value,
    multiple = cascaderContext.multiple,
    treeStore = cascaderContext.treeStore,
    showAllLevels = cascaderContext.showAllLevels;
  if (!multiple) return [];
  if (multiple && !isArray_1(value)) return [];
  var node = treeStore && treeStore.getNodes(value);
  if (!node) return [];
  return value.map(function (item) {
    var _node2$;
    var node2 = treeStore.getNodes(item);
    return showAllLevels ? getFullPathLabel(node2[0]) : (_node2$ = node2[0]) === null || _node2$ === void 0 ? void 0 : _node2$.label;
  }).filter(function (item) {
    return !!item;
  });
}
function getPanels(treeNodes) {
  var panels = [];
  treeNodes.forEach(function (node) {
    if (panels[node.level]) {
      panels[node.level].push(node);
    } else {
      panels[node.level] = [node];
    }
  });
  return panels;
}
function getFullPathLabel(node) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
  return node === null || node === void 0 ? void 0 : node.getPath().map(function (node2) {
    return node2.label;
  }).join(separator);
}
var getTreeValue = function getTreeValue(value) {
  var treeValue = [];
  if (isArray_1(value)) {
    if (value.length > 0 && isObject_1(value[0])) {
      treeValue = value.map(function (val) {
        return val.value;
      });
    } else if (value.length) {
      treeValue = value;
    }
  } else if (value) {
    if (isObject_1(value)) {
      treeValue = [value.value];
    } else {
      treeValue = [value];
    }
  }
  return treeValue;
};
var getCascaderValue = function getCascaderValue(value, valueType, multiple) {
  if (valueType === "single") {
    return value;
  }
  if (multiple) {
    return value.map(function (item) {
      return item[item.length - 1];
    });
  }
  return value[value.length - 1];
};
function isEmptyValues(value) {
  if (isNumber_1(value) && !isNaN(value)) return false;
  return isEmpty_1(value);
}
function isValueInvalid(value, cascaderContext) {
  var multiple = cascaderContext.multiple,
    showAllLevels = cascaderContext.showAllLevels;
  return multiple && !isArray_1(value) || !multiple && isArray_1(value) && !showAllLevels;
}

export { getCascaderValue, getFullPathLabel, getMultipleContent, getPanels, getSingleContent, getTreeValue, isEmptyValues, isValueInvalid };
//# sourceMappingURL=helper.mjs.map
